/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { FormattedMessage } from 'react-intl';
import { Divider } from '@mui/material';
import DialogButton from '../../ui/utils/DialogButton';

class ConfirmDialog extends React.Component {
	static propTypes = {
		open: PropTypes.bool,
		onConfirm: PropTypes.func.isRequired,
		onCancel: PropTypes.func.isRequired,
		title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
		content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
		style: PropTypes.object,
		confirmMessage: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
		cancelMessage: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
	};
	static defaultProps = {
		content: '',
		style: {
			content: {
				margin: '20px 10px 10px 5px'
			},
			title: {}
		},
		open: false,
		confirmMessage: undefined,
		cancelMessage: undefined
	};

	onConfirm = (event) => this.props.onConfirm(event);
	onCancel = (event) => this.props.onCancel(event);

	render() {
		const { title, content, style, open, confirmMessage, cancelMessage } = this.props;
		return (
			<div>
				<Dialog open={open}>
					<DialogTitle style={style.title}>{title}</DialogTitle>
					<DialogContent style={style.content}>{content}</DialogContent>
					<Divider />
					<DialogActions>
						<DialogButton onClick={this.onCancel} margin>
							{cancelMessage || <FormattedMessage id="Cancel" defaultMessage="Cancel" />}
						</DialogButton>
						<DialogButton data-action="confirm" onClick={this.onConfirm} autoFocus margin>
							{confirmMessage || <FormattedMessage id="Confirm" defaultMessage="Confirm" />}
						</DialogButton>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}
export default ConfirmDialog;
